// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"742e027b","137":"05b16fed","810":"742e027b"}[chunkId] + ".chunk.css";
};